import { css } from "@compiled/react";

import { useCohort } from "@/components/user-context";
import type { ExistingSite } from "@/libraries/bxp-web-stargate-client/src";

import { SiteActivationContextProvider } from "./hooks";
import { SiteActivationSwitcher } from "./site-activation-switcher";

export const SiteActivation = (props: {
    ExistingUser?: React.ReactNode;
    ManagedUser?: React.ReactNode;
    NewUser?: React.ReactNode;
    WeekOneUser?: React.ReactNode;
    UpgradeEligibleUser?: React.ReactNode;
    CurrentProductUser?: React.ReactNode;
    UpliftEligibleUser?: React.ReactNode;
    CrossflowEligibleUser?: React.ReactNode;
    existingSites?: ExistingSite[];
}) => {
    const cohort = useCohort();

    return (
        <div
            css={siteActivationCss}
            data-testid="site-activation"
            data-cohort={cohort}
        >
            <SiteActivationContextProvider existingSites={props.existingSites}>
                <SiteActivationSwitcher {...props} />
            </SiteActivationContextProvider>
        </div>
    );
};

// fill the available space in the parent container
const siteActivationCss = css({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
});
